import React from "react";
import { connect } from "react-redux";
import { Route, withRouter, Redirect } from "react-router-dom";

const AuthRoute = props => {
    const { isAuthUser, type } = props;
    // console.log(isAuthUser());
    if (type === "private" && !isAuthUser) {
        return <Redirect to="/login" />;
    }
    else if (!!isAuthUser && props.path === '/login') {
        return <Redirect to="/main" />
    }
    else {
        // console.log('in else')
        return <Route {...props} permissions={props.user.permissions} />
    };
    // return <></>;
};


const mapStateToProps = ({ reducer: store }) => ({
    isAuthUser: store.isAuthUser, user: store.user
});

export default connect(mapStateToProps)(withRouter(AuthRoute));